'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductInfo = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

require('slick-carousel');

var _CarouselSection2 = require('./../carousel/CarouselSection');

var _ShopifySection = require('./../ShopifySection');

var _Accordion = require('./../../objects/accordion/Accordion');

var _AccordionInset = require('./../../objects/accordion/AccordionInset');

var _Responsive = require('./../../settings/Responsive');

var ResponsiveSizes = _interopRequireWildcard(_Responsive);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 *  Product Page Image Carousel
 *    Scripts for the product carousel utilising Slick.
 *
 *
 *  Version:
 *    1.0.0 - 2020/03/12
 */

var CONTAINER_SELECTOR = '[data-product-info]';
var CAROUSEL_SELECTOR = '[data-product-info-carousel]';
var SPECS_ACCORDION_SELECTOR = '[data-product-specs-accordion]';
var DESCRIPTION_SELECTOR = '[data-product-info-description]';

var ProductInfo = exports.ProductInfo = function (_CarouselSection) {
  (0, _inherits3.default)(ProductInfo, _CarouselSection);

  function ProductInfo(container) {
    (0, _classCallCheck3.default)(this, ProductInfo);

    var _this = (0, _possibleConstructorReturn3.default)(this, (ProductInfo.__proto__ || Object.getPrototypeOf(ProductInfo)).call(this, container));

    _this.container = container;
    _this.carouselContainer = container.find(CAROUSEL_SELECTOR);
    _this.description = container.find(DESCRIPTION_SELECTOR);

    //Accordion
    var accordion = container;
    if (accordion && accordion.length) {
      _this.accordion = new _Accordion.Accordion(accordion);
    }
    $('[data-accordion-title][data-index="0"]').click();

    //Specs accordion
    var specsAccordion = container.find(SPECS_ACCORDION_SELECTOR);
    if (specsAccordion && specsAccordion.length) {
      _this.specsAccordion = new _AccordionInset.AccordionInset(accordion);
    }
    specsAccordion.find('[data-specs-accordion-first]').click();

    //Carousel
    _this.slickInit = false;
    _this.container.on('unslick', CAROUSEL_SELECTOR, function () {
      return _this.onUnslick();
    });
    $(window).on('resize orientationchange', function () {
      return _this.onResize();
    });
    _this.onResize();

    //Description table
    _this.description.find('table').wrap('<div class="c-product-info__description-table"></div>');
    return _this;
  }

  (0, _createClass3.default)(ProductInfo, [{
    key: 'optionOverrides',
    value: function optionOverrides() {
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false,
        arrows: false,
        responsive: [{
          breakpoint: ResponsiveSizes.medium - 1,
          settings: "unslick"
        }]
      };
    }
  }, {
    key: 'onUnslick',
    value: function onUnslick() {
      this.slickInit = false;
    }
  }, {
    key: 'onResize',
    value: function onResize() {
      if (this.slickInit) return;
      var windowWidth = $(window).width();

      if (windowWidth < ResponsiveSizes.medium && !this.slickInit) {
        this.slick = this.initCarousel(this.carouselContainer);
        this.slickInit = true;
      } else if (windowWidth >= ResponsiveSizes.medium) {
        this.slickInit = false;
      }
    }
  }]);
  return ProductInfo;
}(_CarouselSection2.CarouselSection);

(0, _ShopifySection.register)(CONTAINER_SELECTOR, ProductInfo);